import React from 'react';
import './OrganizerInfoSection.css';

const OrganizerInfoSection = ({ organizer }) => {
  const details = [
    { label: "Organizer Id", value: organizer.id },
    { label: 'Organizer Name', value: organizer.name },
    { label: 'Organizer Email', value: organizer.email },
    { label: 'Verified Date', value: organizer.verified_at ? new Date(organizer.verified_at).toLocaleDateString() : 'Unverified' },
    { label: 'Processed Requests', value: organizer.ProcessedRequestsCount },
    { label: 'Processed Requests Other Events', value: organizer.ProcessedRequestsOtherEventsCount },
    { label: 'Processed Vendor Requests', value: organizer.ProcessedRequestsCountVendor},
    { label: 'Processed Vendor Requests Other Events', value: organizer.ProcessedRequestsOtherEventsCountVendor}
  ];

  return (
    <section className="organizer-info">
      <h2 className="organizer-info__title">Organizer Information</h2>
      <div className="organizer-info__content">
        {details.map((detail, index) => (
          <div key={index} className="organizer-info__row">
            <span className="organizer-info__label">{detail.label}:</span>
            <span className="organizer-info__value">{detail.value}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default OrganizerInfoSection;